import React from 'react';
import { silkscreen as tooltip } from 'pu-data/Tooltips';
import {
  silkscreenSide as defaultSidesOptions,
  silkscreenColor as defaultColorOptions,
} from 'pu-data/SelectOptions';
import SelectDualComponent from './SelectDualComponent';

const Silkscreen = props => (
  <SelectDualComponent
    {...props}
    label="Silkscreen"
    required={props.required}
    tooltip={tooltip}
    nameA="silkscreen_sides"
    defaultOptionsA={props.sidesOptions}
    nameB="silkscreen_color"
    defaultOptionsB={props.colorOptions} />
);

Silkscreen.defaultProps = {
  sidesOptions: defaultSidesOptions,
  colorOptions: defaultColorOptions,
  required: true,
};

export default Silkscreen;
